import { Spin, Icon } from 'antd';

const DashboardIndicator = ({ icon, title, value, color = '#959595ff', footerNote, width = '100%', isSelected = false, onClick, loading = false }) => {
    // Función para aplicar opacidad al color
    const addOpacityToColor = (hexColor, opacity) => {
        // Si el color ya tiene alpha (8 dígitos), reemplazarlo
        if (hexColor.length === 9) {
            const alphaHex = Math.round(opacity * 255).toString(16).padStart(2, '0');
            return hexColor.substring(0, 7) + alphaHex;
        }
        // Si es un color de 6 dígitos, agregar alpha
        const alphaHex = Math.round(opacity * 255).toString(16).padStart(2, '0');
        return hexColor + alphaHex;
    };

    const containerStyle = {
        ...styles.container,
        borderColor: isSelected ? '#2563eb' : addOpacityToColor(color, 0.3),
        borderWidth: isSelected ? '2px' : '3px',
        width: width,
        ...(isSelected && {
            transform: 'scale(1.05)',
            boxShadow: '0 4px 12px rgba(37, 99, 235, 0.3)',
            transition: 'all 0.3s ease'
        }),
        ...(!isSelected && {
            transition: 'all 0.3s ease'
        }),
        cursor: onClick ? 'pointer' : 'default'
    };

    const valueStyle = {
        ...styles.value,
        color: color
    };

    const spinnerIcon = <Icon type="loading" style={{ fontSize: 32, color: color }} spin />;

    return (
        <div style={containerStyle} onClick={onClick}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "flex-start", gap: '20px', alignItems: 'center' }}>
                <div style={styles.iconContainer}>{icon}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                    <span style={{ ...styles.title, color: color }}>{title}</span>
                    {loading ? (
                        <Spin indicator={spinnerIcon} />
                    ) : (
                        <span style={valueStyle}>{value}</span>
                    )}
                    <span style={{ color: 'grey', fontSize: '12px' }}>{footerNote}</span>
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        width: '100%',
        maxWidth: '620px',
        backgroundColor: '#ffffff',
        margin: '0 auto',
        display: 'flex',
        borderRadius: '18px',
        border: '3px solid',
        padding: '8px',
        minHeight: '80px',
        height: '100%',
        boxSizing: 'border-box',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
    iconContainer: {
        fontSize: '24px',
        marginTop: '4px'
    },
    title: {
        fontSize: '15px',
        fontWeight: 'bold',
        color: '#333333',
        lineHeight: '1.3',
        marginBottom: '4px'
    },
    value: {
        fontSize: '32px',
        fontWeight: '600',
        color: '#1a1a1a',
        lineHeight: '1'
    },
    footerNote: {
        fontSize: '10px',
        color: '#666666',
        lineHeight: '1.4',
        marginTop: '12px'
    }
};

export default DashboardIndicator;
